import { AlertCircle } from "lucide-react";

export function QueryError({ message }: { message: string }) {
  return (
    <div className="m-4 rounded-lg border border-red-500/40 bg-red-500/10 p-3 text-sm text-red-200">
      <div className="flex items-center gap-2">
        <AlertCircle className="h-4 w-4" />
        {message}
      </div>
    </div>
  );
}
